import type { FeaturesProperties } from "@/types/features";
import type { UserProfileState } from "@/types/userProfile";
import { isUserProfileSessionReady } from "@/lib/session/isUserProfileSessionReady";

const FEATURES_NOT_HYDRATED_ERROR_MESSAGE =
  "Route access ran before feature flags were hydrated. Ensure RouterProvider mounts only after settings apply (features.data non-null).";

export const requireFeaturesDataForReadySession = (
  profile: UserProfileState,
  featuresData: Partial<FeaturesProperties> | null,
): Partial<FeaturesProperties> | undefined => {
  const sessionReady = isUserProfileSessionReady(profile);
  if (!sessionReady) {
    return undefined;
  }
  if (featuresData == null) {
    throw new Error(FEATURES_NOT_HYDRATED_ERROR_MESSAGE);
  }
  return featuresData;
};
